import { API_REQUEST, GET_FULL_SNAPSHOT_DATA, GET_PREVIOUS_SNAPSHOT_DATA, GET_PREVIOUS_SNAPSHOT_DATA_INTERNAL } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const getFullSnapshotData = (snapshotId: string | number): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/get-full-snapshot-data/${snapshotId}`,
        next: GET_FULL_SNAPSHOT_DATA,
        method: 'GET',
        authorization: true
    }
})

export const getPreviousSnapshotData = (campaignId: string | number): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/get-previous-snapshot-data/${campaignId}`,
        next: GET_PREVIOUS_SNAPSHOT_DATA,
        method: 'GET',
        authorization: true
    }
})

export const getPreviousSnapshotDataInternal = (rollNumber: string, campaignYear: string, profileId: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/get-previous-snapshot-data-internal/${rollNumber}/${campaignYear}/${profileId}`,
        next: GET_PREVIOUS_SNAPSHOT_DATA_INTERNAL,
        method: 'GET',
        authorization: true
    }
})